import {
  ARIA_CHECKED_BY_CHECKBOX_CHECKED,
  ICON_BY_CHECKBOX_CHECKED,
  ICON_CLASSNAME_BY_CHECKBOX_CHECKED,
} from "./consts";
import { AriaChecked, CheckboxChecked } from "./types";

export const getAriaChecked = (checked: CheckboxChecked): AriaChecked =>
  ARIA_CHECKED_BY_CHECKBOX_CHECKED[`${checked}`];

export const getChecked = (checked: CheckboxChecked): boolean =>
  !!checked && checked !== "indeterminate";

export const getCheckboxIcon = (checked: CheckboxChecked) =>
  ICON_BY_CHECKBOX_CHECKED[`${checked}`];

export const getCheckboxIconClassname = (checked: CheckboxChecked) =>
  ICON_CLASSNAME_BY_CHECKBOX_CHECKED[`${checked}`];
